import CryptoJS from "crypto-js";
import Language from '@/assets/js/language/language';
const languageClass = Language.getInstance();
import shareds from '@/assets/js/shared'
const shared = new shareds()

class User {
    //物件建立時產生
    constructor(router){
        this.$router = router

        this.init()
    }

    init(){
        
    }

    saveUserLogin(res){
        //儲存member_id
        const login_info = {
            mode:'login',
            member_id:res.member_id,
            area_id:res.area_id,
            birthday:res.birthday,
            email:shared.newDecrypt(res.email),
            name:shared.newDecrypt(res.name),
            height:parseInt(res.height),
            weight:parseInt(res.weight),
            sex:parseInt(res.sex),
            loginTime:shared.dateTimeFormat(new Date())
        }
        localStorage.setItem('login_info', JSON.stringify(login_info) );
    }

    saveCommunityUserLogin(res){
        console.log('saveCommunityUserLogin=',res)

        const login_info = {
            account:res.account,
            area_id:res.area_id,
            name:res.name,
            loginTime:shared.dateTimeFormat(new Date())
        }
        localStorage.setItem('communityUserLogin', JSON.stringify(login_info) );
        
    }

    getUser(){

        const loginInfo = localStorage.getItem('login_info');
        if (loginInfo) {
            return JSON.parse(loginInfo);
        } 
        return {
            mode:'guest',
            member_id:"",
            area_id:0,
            birthday:"1971-01-01",
            email:"noMail@mail.com",
            name:languageClass.getLanguage('guest'), //
            height:170,
            weight:50,
            sex:1,
            loginTime:shared.dateTimeFormat(new Date())
        };
        
    }

    getCommunityUser(){
        const communityUserLogin = localStorage.getItem('communityUserLogin');
        if (communityUserLogin) {
            return JSON.parse(communityUserLogin);
        } 
        return {
            account:null,
            area_id:0,
            name:'no find Communit name',
            loginTime:''
        };
    }

    saveCommunityUserList(list){
        localStorage.setItem('communityUserList', JSON.stringify(list) );
    }

    getCommunityUserList(){
        const communityUserList = localStorage.getItem('communityUserList');
        if (communityUserList) {
            return JSON.parse(communityUserList);
        } 
        return [];
    }
}
export default User